import React from "react"; 
import "./PropagandaApp.css";
import GooglePlayButton from "../Buttons/GooglePlay";
import AppleStoreButton from "../Buttons/AppleStore";

export default function PropagandaApp() {
  return (
    <section className="download-section">
      <div className="download-content">

        {/* Texto */}
        <div className="download-text">
          <h2>Baixe o App da UEB</h2>
          <p>
            Tenha acesso às carteirinhas, informações e funcionalidades diretamente no seu celular.
          </p>

          <div className="download-buttons">
            <GooglePlayButton />
            <AppleStoreButton />
          </div>
        </div>  
      </div>
    </section>
  );
}
